export default {
	vmodel: {
		default: ''
	},
	name: {
		type: String,
		required: true,
		default: ''
	},
	label: {
		type: String
	},
	inline: {
		type: Boolean,
		default: false
	},
	class: {
		type: String,
		default: 'col-sm-8 col-md-9'
	},
	spinner: {
		type: Boolean,
		default: false
	},
	postfix: {
		type: String,
		default: ''
	},
	options: {
		type: Array,
		default: () => {
			return [];
		}
	},
	select2: {
		type: Boolean,
		default: false
	},
	tags: {
		type: Boolean,
		default: false
	},
	textarea: {
		type: Boolean,
		default: false
	},
	rows: {
		type: Number,
		default: 4
	},
	type: {
		type: String,
		default: 'text'
	},
	placeholder: {
		type: String,
		default: ''
	},
	datepicker: {
		type: Boolean,
		default: false
	},
	dateFormat: {
		type: String,
		default: "DD/MM/YYYY hh:mm A"
	},
	on: {
		type: String,
		default: 'Yes'
	},
	off: {
		type: String,
		default: 'No'
	},
	onValue: {
		type: Number,
		default: 1
	},
	offValue: {
		type: Number,
		default: 0
	},
	onStyle: {
		type: String,
		default: 'danger'
	},
	offStyle: {
		type: String,
		default: 'default'
	},
	prependIcon: {
		type: String
	},
	prependText: {
		type: String
	},
	appendText: {
		type: String
	},
	appendIcon: {
		type: String
	},
	icon: {
		type: String,
		default: ''
	}
}



// WEBPACK FOOTER //
// ./src/components/form/props.js